"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var polyfill_1 = require("./polyfill");
Object.defineProperty(exports, "polyfill", { enumerable: true, get: function () { return polyfill_1.polyfill; } });
//# sourceMappingURL=index.js.map